// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  envSpec: 'U2FsdGVkX1/lgpWTtqkUVdgCa+dJLC6YCCLSU5ruvaE9qxoaQ2d0INl+5nq1rACulCIeuWTexv083K6OaUmhX3I2E0Emg+uibXTL8jvGFBkgV4ipUPgTnOfRoXj0a2B/8dpYZhDTW01IAarXj2E/0KIegnAxKax5UGo9bPxWr+9hwXC75oVJs1z4wzdgW+LNWGfylsx7LNnVnBtsm6RYixN4iOiJo1C+3Mk6cBpTQwQHjXGJ/lopJeD459/fE12PE5ZP7wSM0uQRGsOI9rQh9/d5uvt79YMADOs407gg2dHovJHYEShtH8gocEaZExp3oTYYqxKV+3sFdmw17d8sz21gYzMG0LRI4dyxNLiBEtHvGJlW96xJRTkpGtj3OngCq04lGaKqR1dF9IzLHHcjh75Wef2QifFU0HztOqeAPlc=',
  envSpec2: 'U2FsdGVkX19OKKI1R/BVRqovl6gFAJKNFHmEAkGu7op3WUoVtkuPnE9+/rCmauzl1GryxvzY/n/c8EpwuGHUe+JYJYBZ7NTJfTlay9ld81grVYY0splgJcULd+5O72YCjs9eMpRU2DBXK+3H0+2Z8Bee43v3W5qvWCeGYlkr0UY='
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
